export default () => ({
  dialog: false,
  product: null,
  backToEditing: false,
  currentView: 'step-1',
  resubmittedEndingAt: null
})
